import { Experience } from "../Types/Exprience";
import { Lang } from "../Types/Lang";

type Props = {
  propList: Experience[];
  lang: Lang;
  title: string;
};

const ExperienceComponent = ({ propList, lang, title }: Props) => {
  return (
    <section className="cv-section">
      <div className="cv-card space-y-5">
        <h2 className="cv-heading">{title}</h2>

        <div className="cv-timeline">
          {propList.map((experience, index) => (
            <article key={index} className="cv-timeline-item space-y-3">
              <span className="cv-timeline-dot" aria-hidden="true" />
              <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
                <h3 className="cv-subheading">{experience.title[lang]}</h3>
                <span className="cv-meta">
                  {experience.start} – {experience.end}
                </span>
              </div>
              <p className="cv-text font-semibold text-brand-primaryDark dark:text-brand-soft">
                {experience.company[lang]}
              </p>
              <ul className="cv-list-bullets">
                {experience.responsibilities.map((responsibility, idx) => (
                  <li className="cv-text" key={idx}>
                    {responsibility[lang]}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceComponent;
